export default class DataGridHeaderItem {
  constructor(public label: string, public name: string, public options?: any) {}
}
